import SearchBar from "./SearchBar.jsx";
import RoleTable from "./RoleTable.jsx";

export default function MappedRoleList() {
  return (
    <div className="ad-card">

      <div className="ad-card-header">
        <div className="ad-card-title">User Role Mapped</div>
        <SearchBar />
      </div>

      <RoleTable />

    </div>
  );
}